import useSWR from 'swr';

import dashboardMetricsAPI from 'api/dashboardMetricsAPI';

const ENDPOINT = '/api/dashboard-metrics/applicant-source/';

const defaultData = {
  by_candidate: [],
  total: 0,
};

/**
 * Data management wrapper for fetching/caching applicant source metrics.
 *
 * Usage: const { data, isLoading, error } = useApplicantSourceMetrics(filters);
 */
export const useApplicantSourceMetrics = ({
  hiringSeasons,
  schools = [],
  subcategories = [],
  genders = [],
  ethnicities = [],
  statuses = [],
}) => {
  // Using ref/memo doesn't work for this library... need to stringify our deps.
  const key = [
    ENDPOINT,
    hiringSeasons.toString(),
    schools.toString(),
    subcategories.toString(),
    genders.toString(),
    ethnicities.toString(),
    statuses.toString(),
  ];
  const options = { dedupingInterval: 30000, focusThrottleInterval: 30000 };

  const { data, error } = useSWR(
    key,
    () =>
      dashboardMetricsAPI.getApplicantSourceMetrics({
        hiringSeasons,
        schools,
        subcategories,
        genders,
        ethnicities,
        statuses,
      }),
    options
  );

  const isLoading = data === undefined;

  return { data: data ?? defaultData, isLoading, error };
};
